const id_facility_list = {
    "": 'daftar permohonan',
    detail: 'rincian permohonan',

    label: {
        booking_number: 'No. Permohonan',
        search: 'Nama fasilitas / No. Permohonan',
        purpose: 'tujuan peminjaman'
    },

    message: {
        approve_title: "Menyetujui Permohonan",
        approve_text: "Apakah Anda yakin untuk menyetujui permohonan?",
        cancel_title: "Apakah Anda yakin untuk membatalkan permohonan?",
        cancel_text: "Masukkan alasan pembatalan permohonan.",
    },

    error: {
        approve: "Gagal mengkonfirmasi permohonan",
        cancel: "Gagal mebatalkan permohonan",
    },
    success: {
        approve: "Berhasil mengkonfirmasi permohonan",
        cancel: "Berhasil mebatalkan permohonan",
    },
}

export default id_facility_list;